// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-58132f6c]{font-family:Avenir,Helvetica,Arial,sans-serif;color:#000}", ""]);
// Exports
module.exports = exports;
